export const API_TIMEOUT = Number(import.meta.env.VITE_API_TIMEOUT) || 10000;

export const getBaseUrl = (): string => {
  const baseurl = import.meta.env.VITE_API_PATH as string;
  return baseurl + "/api/v1";
};

export const getApiPath = {
  // File Upload APIs
  detectSource: `${getBaseUrl()}/reconciliations/detect-source`,
  fileUpload: `${getBaseUrl()}/upload`,
  fileList: `${getBaseUrl()}/upload/file-list`,
  uploadProgress: `${getBaseUrl()}/upload/progress`,
  deletefileDetail: `${getBaseUrl()}/upload/delete`,

  // File Pickup Config
  uploadApiConfig: `${getBaseUrl()}/upload-api-config`,
  uploadSchedulerConfig: `${getBaseUrl()}/upload-scheduler-config`,
  schedulerHistory: `${getBaseUrl()}/scheduler-history`,

  // System Configuration APIs
  systemConfiguration: `${getBaseUrl()}/config/batch`,

  // Matching Rule APIs:
  getChannelList: `${getBaseUrl()}/channel/`,
  getChannelSourceList: `${getBaseUrl()}/channel/source`,
  saveMatchingRules: `${getBaseUrl()}/matching-rules/`,
  getChannelNetworkList: `${getBaseUrl()}/channel/network`,
  getChannelDetails: `${getBaseUrl()}/matching-rules/search`,
  getAllTxnReports: `${getBaseUrl()}/reconciliations/transactions/reports/all`,
  getAllTransactionsList: `${getBaseUrl()}/reconciliations/transactions/reports/lists/all`,

  // Atm channel APi
  getAtmChannelList: `${getBaseUrl()}/reconciliations/transactions`,
  getAtmChannelSummery: `${getBaseUrl()}/reconciliations/transactions/count`,
  searchAtmChannelList: `${getBaseUrl()}/transactions/search/smart`,

  // Mobile Money channel APi
  getMobileMoneyChannelList: `${getBaseUrl()}/reconciliations/transactions`,

  // Recon Audit
  getReconAuditList: `${getBaseUrl()}/reconciliation-runs`,

  // Flexcube API
  getFlexcubeGlLookup: `${getBaseUrl()}/flexcube/gl-master/lookup`,
  getFlexcubeAcvwAllAcEntries: `${getBaseUrl()}/flexcube/acvw-all-ac-entries`,
  getFlexcubeActbHistory: `${getBaseUrl()}/flexcube/actb-history`,
  getFlexcubeActbDailyLog: `${getBaseUrl()}/flexcube/actb-daily-log`,

  // System Administrayions APIS
  systemModules: `${getBaseUrl()}/system/module`,
  systemRoles: `${getBaseUrl()}/system/roles`,
  systemUser: `${getBaseUrl()}/system/user`,
  systemCheckUserEmail: `${getBaseUrl()}/system/user/check-email`,
  systemCheckUserName: `${getBaseUrl()}/system/user/check-username`,

  // dashboard
  getDashboardSummary: `${getBaseUrl()}/dashboard/transaction-reconciliation-metrics`,

  userIdealTimeAPI: `${getBaseUrl()}/channel/set_active`,

} as const;

export const getCommonHeaders = () => {
  const token = localStorage.getItem("access_token"); // or sessionStorage

  return {
    "Content-Type": "application/json",
    ...(token && { Authorization: `Bearer ${token}` }),
  };
};

export const getCommonToken = () => {
  const token = localStorage.getItem("access_token"); // or sessionStorage

  return {
    ...(token && { Authorization: `Bearer ${token}` }),
  };
};

export const handleApiError = (error: unknown, context?: string): never => {
  if (error instanceof Error) {
    console.error(context ?? "API Error:", error.message);
    throw error;
  }

  console.error(context ?? "Unknown API Error:", error);
  throw new Error("Something went wrong. Please try again.");
};

export const handleApiResponse = async (response: Response) => {
  if (response.status === 401) {
    localStorage.removeItem("access_token");
    localStorage.removeItem("user");
    localStorage.removeItem("channels_list");
    localStorage.removeItem("user_role_details");
    window.location.href = "/login";  // redirect to login
    throw new Error("Session expired or invalid token");
  }

  if (!response.ok) {
    const errorBody = await response.text().catch(() => null);
    throw new Error(
      `HTTP ${response.status}: ${errorBody || response.statusText}`,
    );
  }
  return response.json();
};

// remove this later
export const API = {
  upload: "/api/v1/uplaod" as const,
  getAtmTransactionsMatchingCount: "api/v1/atm-matching-count" as const,
  getAtmMatchingTransactions: "api/v1/atm-matching" as const,
  getATMPartiallyMatch: "api/v1/atm-partially-matching" as const,
  getATMNotMatch: "api/v1/atm-not-matching" as const,
  getAtmTransactionsMatchingSummery: "api/v1/recon-atm-matching" as const,
  deletedAllDatabaseTable: "api/v1/clear-data" as const,
  getTransactionByRRN: "api/v1/transaction" as const,
  getSummaryBasedOnRrn: "api/v1/transaction" as const,
};

export const ENDPOINTS = {
  upload: `${getBaseUrl()}${API.upload}`,
  // getAllMatching: `${getBaseUrl()}${API.getAllMatching}?offset=0&limit=100&tpye=1`,
  // getPartiallyMatch: `${getBaseUrl()}${API.getPartiallyMatch}?offset=0&limit=100`,
  // getMismatch: `${getBaseUrl()}${API.getMismatch}?offset=0&limit=20&tpye=1`,
};
